import React from 'react';

import Alert from '@mui/material/Alert';
import Link from '@mui/material/Link';
// import Link from '@mui/material/Image';

import OpenInNew from '@mui/icons-material/OpenInNew';
import MoreVert from '@mui/icons-material/MoreVert';
import Android from '@mui/icons-material/Android';
import Settings from '@mui/icons-material/Settings';

import PlayBooksIcon from '@/images/epub/common/play_books_icon.svg'
import Phrase01Capture from '@/images/epub/self-affirmation/phrase_01_capture.png'
import PlaybookTtsSetting from '@/images/epub/self-affirmation/playbook_tts_setting.png'
import CoverImage from '@/images/epub/self-affirmation/cover.png'
import PlaybookScreenshot from '@/images/epub/self-affirmation/playbook_screenshot.jpg'
import AndroidTtsSetting from '@/images/epub/self-affirmation/android_tts_setting.png'
import GalaxyTtsSetting from '@/images/epub/self-affirmation/galaxy_tts_setting.png'

const PlayBookOpenView = () => {

  return (<div>
    <h1><span className="mb-4 pr-3 text-3xl font-bold leading-normal">Play 북 구매자를 위한 도움말</span><span className="text-gray-500">수정 2023-12-29</span></h1>
    <p className="mt-8 text-lg">
      미쁨에듀를 이용해주셔서 감사합니다.<br />
      이 곳은 Play 북에서 『영어로 하는 미쁨 자기긍정확언』 전자책을 구매하신 분들을 위한 도움말입니다.
    </p>
    
    <p className="my-4 text-lg ">
      이 책은 자기 긍정 확언을 영어 문장들로 할 수 있는 전자책입니다.<br />
      나를 아끼는데는 자기 긍정이 필요합니다.<br />
      이 책을 이용하면, 영어 학습과 자기 긍정을 동시에 할 수 있어요.
    </p>

    <p className='flex justify-center'>
      <img className="border-2 w-[250px]" src={CoverImage} />
    </p>
    <p className='flex justify-center'>
      <img className='w-4' src={PlayBooksIcon} />
      <Link href="https://play.google.com/store/books/details?id=jHnqEAAAQBAJ"><span>Play북 구매</span><OpenInNew sx={{fontSize: 15}} /></Link>
    </p>

    <p className="my-4 text-lg">전자책이기 때문에 TTS(읽어주기) 기능을 사용할 수 있어요.<br />TTS 기능으로 영어 학습과 명상의 효과를 최대로 이끌어 내보세요.</p>
   
    <Alert severity="warning" className="text-lg">
      <span className="text-lg">안드로이드 휴대폰이 아닌 경우, TTS 사용에 제약이 있습니다.<br /> 이를 위해, 다른 플랫폼에서 출판을 준비하고 있습니다.</span>
    </Alert>
    
    <h2 className="my-4 text-2xl font-bold leading-normal">일반적인 사용법</h2>
    <p className="my-4 text-lg">
      『영어로 하는 미쁨 자기긍정확언』은 나를 긍정해 주는 확언 문구 80개로 구성되어 있습니다.<br />
      각 문장들을 되뇌면서, 영어에 익숙해짐과 동시에 삶이 풍요로워지는 것을 느껴보세요.
    </p>
    <p className='flex justify-center'>
      <img className="border-2 w-[250px]" src={PlaybookScreenshot} />
    </p>
    <p className="my-4 text-lg">
      쉬운 단어들과 간단한 문법을 위주로 구성하였습니다.<br />
      그래도 이해를 도울 수 있도록 해석과 단어 설명을 추가해두었습니다.<br />
      이를 이용해서 빠르게 습득하여 보세요. 
    </p>
    <p className="my-4 text-lg">
      80개 문장을 이해하는데 수월하시다면, 반복 명상으로 이 문장들을 음미해 보세요.
    </p>

    <h2 className="my-4 text-2xl font-bold leading-normal">반복 명상 활용법</h2>
    <p className="my-4 text-lg">
      Play 북 더보기(<MoreVert className='border-2' />)를 누르시면 소리내어 읽기(TTS 기능)가 나옵니다.<br />
      (<Android />안드로이드 폰 한정)
    </p>
    <p className='flex justify-center'>
      <img className="border-2 w-[250px]" src={PlaybookTtsSetting} />
    </p>
    <p className="my-4 text-lg">
      TTS 를 활용하시면, 각 문장을 5번씩 읽어줍니다.<br />
      80개의 문장을 반복해서 들으면서 나의 긍정을 받아들여보세요.
    </p>
    
    <h2 className="my-4 text-2xl font-bold leading-normal">소리내어 읽기(TTS 기능) 설정</h2>

    <p className="my-4 text-lg">
      안드로이드의 "글자 읽어주기" 설정(<Settings /> 설정 &gt; 일반 &gt; 글자 읽어주기)으로 TTS 를 설정할 수 있습니다. <br />
      읽어주는 속도, 톤, 기본 엔진(목소리)를 조정할 수 있습니다.
    </p>

    <p className='flex justify-center'>
      <img className="border-2 w-[800px]" src={AndroidTtsSetting} />
    </p>

    <p className="my-4 text-lg">
      Galaxy 폰읜 경우, 기본 엔진(목소리) 설정은 Galaxy Store 을 이용합니다.<br />
      기본음성 데이터 보다는 다른 데이터를 사용하시길 추천드려요.
    </p>

    <p className='flex justify-center'>
      <img className="border-2 w-[800px]" src={GalaxyTtsSetting} />
    </p>

  </div>);
};

export default PlayBookOpenView;
